import { useEffect } from "react";
import { useNavigate, useParams, Outlet } from "react-router-dom";

import { getWorkspaceById } from "../api/workspace";

export default function CheckWorkspaceExist() {
  const { workspaceId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getWorkspaceById(workspaceId).catch(() => navigate("/home"));
  }, []);

  return <Outlet />;
}
